import { normalizeScheduleTimeInput } from "./scheduleUtils";

export function parseTime24(value) {
  const normalized = normalizeScheduleTimeInput(value);
  const [hours24, minute] = normalized.split(":").map(Number);
  const period = hours24 >= 12 ? "PM" : "AM";
  let hour12 = hours24 % 12;
  if (hour12 === 0) hour12 = 12;
  return { hour12, minute, period };
}

export function toTime24(hour12, minute, period) {
  let hours24 = hour12 % 12;
  if (period === "PM") hours24 += 12;
  return normalizeScheduleTimeInput(
    `${String(hours24).padStart(2, "0")}:${String(minute).padStart(2, "0")}`,
  );
}

export function formatTimeDisplay(value) {
  const { hour12, minute, period } = parseTime24(value);
  return `${String(hour12).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
}
